import { UIMSingletonPageView } from '../ui_html/singleton_page/UIMSingletonPageView.ts';
import { isSubscriptionOverlayVisible } from '../../../shared/scripts/store/subscription_overlay/subscriptionOverlayABTest.ts';
import { EntryShared } from '../../../shared/scripts/EntryShared.ts';
import { matchMobileRoute } from './MobileRouteResolver.ts';
export class UIMFullscreenPageController {
    openUrl(pageUrl) {
        var _this_getPageContainer;
        const page = this.getPage(pageUrl);
        page.build();
        this.pageStack.push(page);
        var _matchMobileRoute;
        EntryShared.sendPageVisitAnalyticEvent((_matchMobileRoute = matchMobileRoute(pageUrl)) !== null && _matchMobileRoute !== void 0 ? _matchMobileRoute : pageUrl);
        if (isSubscriptionOverlayVisible()) (_this_getPageContainer = this.getPageContainer()) === null || _this_getPageContainer === void 0 ? void 0 : _this_getPageContainer.classList.add('above-subscription-overlay');
    }
    closePage() {
        const currentPage = this.pageStack.pop();
        currentPage === null || currentPage === void 0 ? void 0 : currentPage.removeFromDOM();
        if (this.pageStack.length == 0) {
            var _this_getPageContainer;
            (_this_getPageContainer = this.getPageContainer()) === null || _this_getPageContainer === void 0 ? void 0 : _this_getPageContainer.classList.remove('above-subscription-overlay');
            return;
        }
        const previousPage = this.pageStack[this.pageStack.length - 1];
        previousPage.build();
    }
    closeAllPages() {
        var _this_getPageContainer;
        this.pageStack.forEach((page)=>page.removeFromDOM());
        this.pageStack.length = 0;
        (_this_getPageContainer = this.getPageContainer()) === null || _this_getPageContainer === void 0 ? void 0 : _this_getPageContainer.classList.remove('above-subscription-overlay');
    }
    // eslint-disable-next-line class-methods-use-this
    getPageContainer() {
        return document.getElementById('fullscreen-page-container');
    }
    createPage(pageUrl) {
        const page = new UIMSingletonPageView(pageUrl, ()=>this.closePage());
        this.renderedPageList.push(page);
        return page;
    }
    getPage(pageUrl) {
        const page = this.getIfPageIsPreRendered(pageUrl);
        if (page) return page;
        return this.createPage(pageUrl);
    }
    getIfPageIsPreRendered(pageUrl) {
        return this.renderedPageList.find((page)=>page.pageId == pageUrl);
    }
    constructor(){
        this.renderedPageList = [];
        this.pageStack = [];
    }
}
